import bo1 from "./bo-1.jpg";
import bo2 from "./bo-2.jpg";
import bo3 from "./bo-3.jpg";
import bo4 from "./bo-4.jpg";
import bo5 from "./bo-5.jpg";
import bo6 from "./bo-6.jpg";
import bo7 from "./bo-7.jpg";
import bo8 from "./bo-8.jpg";
import bo9 from "./bo-9.jpg";
import bo10 from "./bo-10.jpg";
import bo11 from "./bo-11.jpg";
import bo12 from "./bo-12.jpg";
import bo13 from "./bo-13.jpg";
import bo14 from "./bo-14.jpg";
import bo15 from "./bo-15.jpg";
import bo16 from "./bo-16.jpg";
import bo17 from "./bo-17.jpg";
import bo18 from "./bo-18.jpg";
import bo19 from "./bo-19.jpg";
import bo20 from "./bo-20.jpg";
import bo21 from "./bo-21.jpg";
import bo22 from "./bo-22.jpg";
import bo23 from "./bo-23.jpg";
import bo24 from "./bo-24.jpg";
import bo25 from "./bo-25.jpg";
import bo26 from "./bo-26.jpg";
import boFp3d from "./bo-fp-3d.jpg";
import boFp2d from "./bo-fp-2d.jpg";

export const bohniceImages = [
  bo1, bo2, bo3, bo4, bo5, bo6, bo7, bo8, bo9, bo10,
  bo11, bo12, bo13, bo14, bo15, bo16, bo17, bo18, bo19, bo20,
  bo21, bo22, bo23, bo24, bo25, bo26,
];

export const bohniceFloorPlans = [
  { image: boFp3d, label: "3D půdorys" },
  { image: boFp2d, label: "2D půdorys" },
];
